import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../../Config/Config';
import './ReceivedHstry.css'; // Using the same CSS file from the first component

const History = () => {
  const [activeTab, setActiveTab] = useState('Deposits');
  const [deposits, setDeposits] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  const subscribeToTransactions = (user) => {
    const uid = user.uid;
    const transHistoryRef = doc(db, 'TransHistory', uid);

    const unsubscribe = onSnapshot(
      transHistoryRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          // Sort both deposits and withdrawals by date (newest first)
          const sortedDeposits = (data.depositTrans || []).sort((a, b) => 
            new Date(b.date) - new Date(a.date)
          );
          const sortedWithdrawals = (data.withdrawlTrans || []).sort((a, b) => 
            new Date(b.date) - new Date(a.date)
          );
          setDeposits(sortedDeposits);
          setWithdrawals(sortedWithdrawals);
        } else {
          setDeposits([]);
          setWithdrawals([]);
        }
        setLoading(false);
      },
      (error) => {
        console.error('Error listening to real-time updates:', error);
        setLoading(false);
      }
    );

    return unsubscribe;
  };

  useEffect(() => {
    let unsubscribeFromFirestore = null;

    const unsubscribeFromAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        unsubscribeFromFirestore = subscribeToTransactions(user);
      } else {
        console.log('No user is signed in.');
        setDeposits([]);
        setWithdrawals([]);
        setLoading(false);
      }
    });

    return () => {
      if (unsubscribeFromFirestore) unsubscribeFromFirestore();
      unsubscribeFromAuth();
    };
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const displayedData = activeTab === 'Deposits' ? deposits : withdrawals;

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <div className="loading-text">Loading your transaction history</div>
      </div>
    );
  }

  return (
    <div className="statement-container">
      <div className="statement-header">
        <h2>Transaction History</h2>
        <div className="statement-summary">
          View your {activeTab.toLowerCase()} history
        </div>
      </div>

      <div className="statement-body">
        {/* Tabs */}
        <div className="tabs-container">
          <button
            onClick={() => handleTabClick('Deposits')}
            className={`tab-button ${activeTab === 'Deposits' ? 'active' : ''}`}
          >
            Deposits
          </button>
          <button
            onClick={() => handleTabClick('Withdrawals')}
            className={`tab-button ${activeTab === 'Withdrawals' ? 'active' : ''}`}
          >
            Withdrawals
          </button>
        </div>

        {/* Transaction List */}
        {displayedData.length > 0 ? (
          <div className="transaction-list">
            {displayedData.map((transaction, index) => (
              <div key={index} className="transaction-item">
                <div className="transaction-date-column">
                  <div className="transaction-date">
                    {new Date(transaction.date).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric'
                    })}
                  </div>
                  <div className="transaction-time">
                    {new Date(transaction.date).toLocaleTimeString('en-US', {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </div>
                </div>

                <div className="transaction-details">
                  <div className="transaction-type">{activeTab}</div>
                  <div className="transaction-status completed">Completed</div>
                </div>

                <div className={`transaction-amount ${
                  activeTab === 'Deposits' ? 'deposit' : 'withdrawal'
                }`}>
                  {activeTab === 'Deposits' ? '+' : '-'}$
                  {transaction.amount.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">💳</div>
            <h3>No transactions yet</h3>
            <p>Your {activeTab.toLowerCase()} history will appear here</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default History;